import React from "react";

function PreviewContent(props) {
  var doc = props.document;
  var logoUrl = props.logoUrl;
  var ref = props.innerRef;

  var subtotal = 0;
  var totalDiscount = 0;
  for (var i = 0; i < doc.items.length; i++) {
    subtotal += doc.items[i].quantity * doc.items[i].unitPrice;
    totalDiscount += doc.items[i].discount || 0;
  }
  var baseImponible = subtotal - totalDiscount;
  var tax = baseImponible * (doc.taxRate / 100);
  var irpf = doc.irpfRate ? baseImponible * (doc.irpfRate / 100) : 0;
  var total = baseImponible + tax - irpf;

  function fmt(n) {
    return new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(n);
  }

  function fmtDate(d) {
    if (!d) return "-";
    return new Date(d).toLocaleDateString("es-ES", { day: "2-digit", month: "long", year: "numeric" });
  }

  return (
    <div ref={ref} className="bg-white" style={{ minHeight: "1100px", fontFamily: "'Manrope', sans-serif" }}>
      {/* Clean White Header */}
      <div className="bg-white p-8 pb-6">
        <div className="flex justify-between items-start">
          <div className="flex items-center gap-6">
            <img src={logoUrl} alt="Logo" className="h-24 w-auto object-contain" style={{ maxWidth: "180px" }} />
            <div className="border-l-2 border-slate-200 pl-6">
              <h2 className="text-xl font-bold text-slate-800">{doc.company.name || "EMPRESA"}</h2>
              <p className="text-slate-500 text-sm">{doc.company.address}</p>
              <p className="text-slate-500 text-sm">{doc.company.postalCode} {doc.company.city}</p>
              {doc.company.cif && <p className="text-slate-500 text-sm">CIF: {doc.company.cif}</p>}
              {doc.company.phone && <p className="text-slate-500 text-sm">Tel: {doc.company.phone}</p>}
            </div>
          </div>
          <div className="text-right">
            <p className="text-sm text-slate-400 uppercase tracking-wider mb-1">{doc.type === "invoice" ? "Factura Nº" : "Presupuesto Nº"}</p>
            <p className="text-3xl font-bold text-slate-800">{doc.number}</p>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="h-1 bg-slate-800 mx-8"></div>

      {/* Document Info Bar */}
      <div className="bg-slate-50 mx-8 mt-0 px-6 py-4 flex justify-between text-sm">
        <div className="flex gap-8">
          <div>
            <span className="text-slate-400 text-xs uppercase">Fecha Emisión</span>
            <p className="font-semibold text-slate-700">{fmtDate(doc.date)}</p>
          </div>
          {doc.dueDate && (
            <div>
              <span className="text-slate-400 text-xs uppercase">Fecha Vencimiento</span>
              <p className="font-semibold text-slate-700">{fmtDate(doc.dueDate)}</p>
            </div>
          )}
        </div>
      </div>

      <div className="p-8 pt-6">
        {/* Client Box */}
        <div className="mb-8 p-6 bg-slate-50 rounded-lg border-l-4 border-slate-800">
          <p className="text-xs text-slate-500 font-bold uppercase tracking-wider mb-2">Facturar a:</p>
          <h3 className="text-xl font-bold text-slate-900 mb-1">{doc.client.name || "Cliente"}</h3>
          <p className="text-slate-600">{doc.client.address}</p>
          <p className="text-slate-600">{doc.client.postalCode} {doc.client.city}</p>
          <div className="mt-3 pt-3 border-t border-slate-200 flex gap-6 text-sm">
            <p><span className="text-slate-400">CIF/NIF:</span> <span className="font-medium">{doc.client.cif || "-"}</span></p>
            {doc.client.phone && <p><span className="text-slate-400">Tel:</span> <span className="font-medium">{doc.client.phone}</span></p>}
          </div>
        </div>

        {/* Items Table */}
        <div className="mb-8">
          <table className="w-full">
            <thead>
              <tr className="bg-slate-800 text-white">
                <th className="text-left p-4 rounded-tl-lg font-semibold">Descripción</th>
                <th className="text-center p-4 w-16 font-semibold">Ud.</th>
                <th className="text-right p-4 w-28 font-semibold">Precio</th>
                <th className="text-right p-4 w-24 font-semibold">Dto.</th>
                <th className="text-right p-4 w-28 rounded-tr-lg font-semibold">Importe</th>
              </tr>
            </thead>
            <tbody>
              {doc.items.map(function(item, i) {
                var lineTotal = (item.quantity * item.unitPrice) - (item.discount || 0);
                return (
                  <tr key={item.id} className={i % 2 === 0 ? "bg-white" : "bg-slate-50"}>
                    <td className="p-4 border-b border-slate-100">
                      <div className="font-semibold text-slate-800">{item.description || "Sin descripción"}</div>
                      {item.details && (
                        <div className="mt-2 text-xs text-slate-500 whitespace-pre-line leading-relaxed">
                          {item.details}
                        </div>
                      )}
                    </td>
                    <td className="text-center p-4 border-b border-slate-100 font-medium text-slate-700">{item.quantity}</td>
                    <td className="text-right p-4 border-b border-slate-100 text-slate-700">{fmt(item.unitPrice)}</td>
                    <td className="text-right p-4 border-b border-slate-100 text-red-500 font-medium">{item.discount > 0 ? "-" + fmt(item.discount) : "-"}</td>
                    <td className="text-right p-4 border-b border-slate-100 font-bold text-slate-800">{fmt(lineTotal)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Totals */}
        <div className="flex justify-end mb-8">
          <div className="w-80 bg-slate-50 rounded-lg p-6">
            <div className="space-y-3 text-sm">
              <div className="flex justify-between py-2">
                <span className="text-slate-500">Subtotal:</span>
                <span className="font-medium text-slate-700">{fmt(subtotal)}</span>
              </div>
              {totalDiscount > 0 && (
                <div className="flex justify-between py-2 text-red-500">
                  <span>Descuentos:</span>
                  <span className="font-medium">-{fmt(totalDiscount)}</span>
                </div>
              )}
              <div className="flex justify-between py-2 border-t border-slate-200">
                <span className="text-slate-500">Base Imponible:</span>
                <span className="font-medium text-slate-700">{fmt(baseImponible)}</span>
              </div>
              <div className="flex justify-between py-2">
                <span className="text-slate-500">IVA ({doc.taxRate}%):</span>
                <span className="font-medium text-slate-700">{fmt(tax)}</span>
              </div>
              {doc.irpfRate > 0 && (
                <div className="flex justify-between py-2 text-orange-600">
                  <span>IRPF ({doc.irpfRate}%):</span>
                  <span className="font-medium">-{fmt(irpf)}</span>
                </div>
              )}
            </div>
            <div className="flex justify-between items-center mt-4 p-4 bg-slate-800 rounded-lg text-white">
              <span className="text-lg font-bold">TOTAL</span>
              <span className="text-2xl font-bold">{fmt(total)}</span>
            </div>
          </div>
        </div>

        {/* Notes and Payment */}
        {(doc.notes || doc.paymentTerms) && (
          <div className="grid grid-cols-2 gap-6 mt-8 pt-6 border-t border-slate-200">
            {doc.notes && (
              <div className="p-4 bg-amber-50 rounded-lg border border-amber-100">
                <h4 className="text-xs font-bold text-amber-700 uppercase tracking-wider mb-2">Observaciones</h4>
                <p className="text-sm text-slate-600 whitespace-pre-line">{doc.notes}</p>
              </div>
            )}
            {doc.paymentTerms && (
              <div className="p-4 bg-emerald-50 rounded-lg border border-emerald-100">
                <h4 className="text-xs font-bold text-emerald-700 uppercase tracking-wider mb-2">Forma de Pago</h4>
                <p className="text-sm text-slate-600 whitespace-pre-line">{doc.paymentTerms}</p>
              </div>
            )}
          </div>
        )}

        {/* Footer */}
        <div className="mt-12 pt-6 border-t border-slate-200 text-center">
          <p className="text-sm font-semibold text-slate-700">{doc.company.name || "Empresa"}</p>
          <p className="text-xs text-slate-400 mt-1">{doc.company.address} • {doc.company.postalCode} {doc.company.city}</p>
          <p className="text-xs text-slate-400">Tel: {doc.company.phone || "-"} • {doc.company.email || "-"} • CIF: {doc.company.cif || "-"}</p>
        </div>
      </div>
    </div>
  );
}

export default PreviewContent;
